/* eslint-disable import/no-default-export */
import React from 'react';

import LargeBanner from './large-team-boards-cta-banner';
import NarrowBanner from './narrow-team-boards-cta-banner';
import SmallBanner from './small-team-boards-cta-banner';

interface CtaJoinBoardBannerProps {
  inBoardsMenu?: boolean;
  largeBanner?: boolean;
  teamName: string;
  teamBoardsLink: string;
  onDismiss: () => void;
  onClickLink?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

const CtaJoinBoardBanner = ({
  inBoardsMenu,
  largeBanner,
  ...props
}: CtaJoinBoardBannerProps) => (
  <>
    {inBoardsMenu && <NarrowBanner {...props} />}
    {!inBoardsMenu && largeBanner && <LargeBanner {...props} />}
    {!inBoardsMenu && !largeBanner && <SmallBanner {...props} />}
  </>
);

export default CtaJoinBoardBanner;



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-boards-cta/index.tsx